import { render, staticRenderFns } from "./GExamDetailProgress.vue?vue&type=template&id=506c9b1f&scoped=true&"
import script from "./GExamDetailProgress.vue?vue&type=script&lang=ts&"
export * from "./GExamDetailProgress.vue?vue&type=script&lang=ts&"
import style0 from "./GExamDetailProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c9b1f",
  null
  
)

export default component.exports